import React, { ReactNode } from 'react'

import { LinearProgress as MUILinearProgress } from '@mui/material'
import { Color } from 'themes'

import Box from '../Box'
import Text from '../Text'

export interface LinearProgressProps {
  color?: Color | 'brand' | 'error' | 'info' | 'success' | 'warning'
  customLabel?: ReactNode
  label?: boolean
  orientation?: 'horizontal' | 'vertical'
  sx?: object
  value?: number
  valueBuffer?: number
  variant?: 'buffer' | 'determinate' | 'indeterminate' | 'query'
}

const LinearProgress = React.forwardRef(
  (props: LinearProgressProps, ref: any) => {
    const {
      customLabel,
      label,
      orientation = 'horizontal',
      sx,
      value,
      ...rest
    } = props
    const limitedValue =
      value === undefined ? undefined : value > 100 ? 100 : value

    if ((label || customLabel) && value !== undefined) {
      return (
        <Box
          sx={{
            display: 'flex',
            gap: 1,
            ...(orientation === 'horizontal'
              ? { alignItems: 'center', flexDirection: 'row' }
              : null),
            ...(orientation === 'vertical'
              ? { flexDirection: 'column' }
              : null),
            ...sx
          }}
        >
          <Box
            sx={{
              ...(orientation === 'horizontal' ? { flex: 1 } : null),
              ...(orientation === 'vertical' ? { width: '100%' } : null)
            }}
          >
            <MUILinearProgress value={limitedValue} {...rest} ref={ref} />
          </Box>
          <Box sx={{ minWidth: 35 }}>
            <Text
              color="text.secondary"
              fontWeight="600"
              sx={{ whiteSpace: 'nowrap' }}
              variant="body2"
            >
              {customLabel ?? `${Math.round(value)}%`}
            </Text>
          </Box>
        </Box>
      )
    }

    return (
      <MUILinearProgress value={limitedValue} {...rest} ref={ref} sx={sx} />
    )
  }
)

LinearProgress.displayName = 'LinearProgress'
export default LinearProgress
